<template>
    <div>
        <b-card no-body v-show="mostrarPropostaPrecoForm">
            <b-card-header>
                <div class="float-left">
                    <span class="h5">{{ tituloPagina }}</span>
                </div>
            </b-card-header>
            <b-card-body>
                <h5>Dados da Solicitação</h5>

                <app-erros-box
                    v-if="erros.length > 0"
                    :erros="erros"
                ></app-erros-box>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <label class="required">Tipo de Contrato</label>
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :options="tiposContrato"
                                text-field="descricao"
                                value-field="valor"
                                :value="tipoContrato"
                                @input="aoSelecionarTipoContrato"
                                :state="$v.tipoContrato.$error ? false : null"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>
                                        Selecione...
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-invalid-feedback>
                                Tipo de Contrato é obrigatório.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <label class="required">Num. da licitação</label>
                            <b-form-input
                                v-model="numeroLicitacao"
                                v-mask="'###/####-AAA'"
                                placeholder="000/0000-XXX"
                                @input.native="$v.numeroLicitacao.$touch()"
                                :state="
                                    $v.numeroLicitacao.$error ? false : null
                                "
                            />
                            <b-form-invalid-feedback
                                v-if="
                                    !$v.numeroLicitacao.required &&
                                    $v.numeroLicitacao.$dirty
                                "
                            >
                                Número da licitação é obrigatório.
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback
                                v-if="
                                    !$v.numeroLicitacao.formatoValido &&
                                    $v.numeroLicitacao.$dirty
                                "
                            >
                                Formato do número da licitação é inválido.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <label class="required">
                                Objeto da contratação
                            </label>
                            <b-form-input
                                v-model="objetoContratacao"
                                @input="$v.objetoContratacao.$touch()"
                                :state="
                                    $v.objetoContratacao.$error ? false : null
                                "
                            />
                            <b-form-invalid-feedback>
                                Objeto da contratação é obrigatório.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <label class="required">Encargos Sociais</label>
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :options="encargosSociaisOrcaFascio"
                                text-field="descricao"
                                value-field="descricao"
                                v-model="encargosSociais"
                                @input="$v.encargosSociais.$touch()"
                                :state="
                                    $v.encargosSociais.$error ? false : null
                                "
                            ></b-form-select>
                            <b-form-invalid-feedback>
                                Encargos Sociais é obrigatório.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <label :class="{ required: ehContratoDeEngenharia }">Bancos</label>
                            <b-card>
                                <b-row>
                                    <b-col>
                                        <b-form-group>
                                            <label :class="{ required: ehContratoDeEngenharia }">
                                                Banco
                                            </label>
                                            <b-form-select
                                                class="mb-2 mr-sm-2 mb-sm-0"
                                                :options="bancosOrcaFascio"
                                                text-field="descricao"
                                                value-field="descricao"
                                                v-model="banco"
                                            >
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Selecione...
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>

                                    <b-col>
                                        <b-form-group>
                                            <label :class="{ required: ehContratoDeEngenharia }">
                                                Mês/Ano de Referência
                                            </label>
                                            <date-picker
                                                v-model="mesAnoReferencia"
                                                :config="$monthPickerOptions"
                                                v-mask="'##/####'"
                                            />
                                            <b-form-invalid-feedback>
                                                Mês/Ano de Referência é
                                                obrigatório.
                                            </b-form-invalid-feedback>
                                            <div
                                                v-if="mesAnoReferenciaFutura"
                                                class="text-danger mt-1"
                                                style="font-size: 0.875rem"
                                            >
                                                Mês/Ano de Referência deve ser anterior ao mês vigente.
                                            </div>
                                        </b-form-group>
                                    </b-col>

                                    <b-col>
                                        <b-form-group>
                                            <label :class="{ required: ehContratoDeEngenharia }">
                                                Estado
                                            </label>
                                            <b-form-select
                                                class="mb-2 mr-sm-2 mb-sm-0"
                                                :options="estados"
                                                text-field="text"
                                                value-field="value"
                                                v-model="estado"
                                            ></b-form-select>
                                            <b-form-invalid-feedback>
                                                Estado é obrigatório.
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>

                                    <b-col>
                                        <b-button
                                            style="margin-top: 25px"
                                            variant="secondary"
                                            @click="adicionarBanco"
                                            :disabled="
                                                desabilitarBotaoAdicionarBanco
                                            "
                                        >
                                            Adicionar
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <div
                                    v-if="bancoEstaDuplicado"
                                    class="text-danger mb-2"
                                    style="font-size: 0.875rem"
                                >
                                    Este banco já foi adicionado com o mesmo mês/ano e estado.
                                </div>

                                <b-table
                                    class="mb-2"
                                    hover
                                    :items="bancos"
                                    :fields="camposTabela"
                                    :state="$v.bancos.$error ? false : null"
                                >
                                    <template slot="acao" slot-scope="data">
                                        <b-button
                                            variant="danger"
                                            size="sm"
                                            @click.stop="
                                                bancos.splice(data.index, 1)
                                            "
                                        >
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                    </template>
                                </b-table>
                                <b-form-invalid-feedback
                                    :state="$v.bancos.$error ? false : null"
                                >
                                    Informe ao menos um Banco.
                                </b-form-invalid-feedback>
                            </b-card>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <label :class="planilhaRequired">
                                Importar Planilha
                            </label>
                            <div v-if="!ehContratoDeEngenharia && tipoContrato" class="mb-2">
                                <b-button
                                    variant="outline-primary"
                                    size="sm"
                                    class="mr-2"
                                    @click.stop="baixarPlanilhaModelo"
                                >
                                    <i class="fa fa-download mr-2"></i> Baixar Planilha Modelo
                                </b-button>
                                <b-button
                                    variant="outline-primary"
                                    size="sm"
                                    @click.stop="baixarInstrucoes"
                                >
                                    <i class="fa fa-download mr-2"></i> Baixar Instruções
                                </b-button>
                            </div>
                            <div>
                                <b-form-file
                                    ref="selecaoArquivo"
                                    class="planilha-upload-primary"
                                    :placeholder="nomePlanilhaItens || 'Selecione o arquivo...'"
                                    :browse-text="(planilha || nomePlanilhaItens) ? 'Substituir planilha' : 'Selecionar planilha'"
                                    accept=".xlsx, .xls"
                                    @input="aoSelecionarPlanilha"
                                    :state="
                                        $v.planilha.$error ? false : null
                                    "
                                ></b-form-file>
                            </div>
                            <b-form-invalid-feedback
                                :state="$v.planilha.$error ? false : null"
                            >
                                Planilha é obrigatória.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col>
                        <b-button
                            variant="outline-danger"
                            class="mr-2"
                            @click.stop="confirmarCancelar"
                        >
                            Cancelar
                        </b-button>

                        <b-button
                            v-if="$route.name === 'PropostasPrecos_Nova'"
                            variant="primary"
                            @click.stop="salvar()"
                        >
                            Criar Solicitação
                        </b-button>

                        <b-button
                            v-if="$route.name === 'PropostasPrecos_Editar'"
                            variant="primary"
                            @click.stop="atualizar()"
                            :disabled="!planilha && !nomePlanilhaItens"
                        >
                            Atualizar Solicitação
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import PropostaPrecoServico from './PropostaPrecoServico'
import { BancosOrcaFascio, EncargosSociaisOrcaFascio, TiposContrato, TIPOS_COM_BDI } from './OpcoesOrcaFascio'
import { estados2 } from '../../shared/consts/estados'
import { unzipSync } from 'fflate'

export default {
    data() {
        return {
            propostaPrecoId: '',
            numeroLicitacao: '',
            objetoContratacao: '',
            tiposContrato: TiposContrato,
            tipoContrato: null,
            encargosSociaisOrcaFascio: EncargosSociaisOrcaFascio,
            encargosSociais: '',
            bancosOrcaFascio: BancosOrcaFascio,
            banco: null,
            bancos: [],
            bancosFormatado: '',
            mesAnoReferencia: null,
            estados: estados2,
            estado: null,
            nomePlanilhaItens: '',
            planilha: null,
            erros: [],
            camposTabela: [
                { key: 'descricao', label: 'Banco' },
                { key: 'mesAnoReferencia', label: 'Mês/Ano de Referência' },
                { key: 'estado', label: 'Estado' },
                { key: 'acao', label: '' }
            ]
        }
    },

    computed: {
        bancoEstaDuplicado() {
            if (!this.banco || !this.mesAnoReferencia || !this.estado)
                return false

            return this.bancos.some(
                (banco) =>
                    banco.descricao === this.banco &&
                    banco.mesAnoReferencia === this.mesAnoReferencia &&
                    banco.estado === this.estado
            )
        },

        mesAnoReferenciaFutura() {
            if (!this.mesAnoReferencia) return false

            const dataReferencia = this.$moment(
                this.mesAnoReferencia,
                'MM/YYYY',
                true
            )
            if (!dataReferencia.isValid()) return false

            const inicioMesAtual = this.$moment().startOf('month')
            return dataReferencia.isSameOrAfter(inicioMesAtual)
        },

        desabilitarBotaoAdicionarBanco() {
            const naoPreenchido =
                !this.banco || !this.mesAnoReferencia || !this.estado

            return (
                naoPreenchido ||
                this.bancoEstaDuplicado ||
                this.mesAnoReferenciaFutura
            )
        },

        mostrarPropostaPrecoForm() {
            return (
                this.$route.name === 'PropostasPrecos_Nova' ||
                this.$route.name === 'PropostasPrecos_Editar'
            )
        },

        tituloPagina() {
            let acao =
                this.$route.name === 'PropostasPrecos_Nova'
                    ? 'Nova'
                    : 'Atualizar'

            return `${acao} solicitação de proposta de preço`
        },

        planilhaRequired() {
            return this.$route.name === 'PropostasPrecos_Nova' ? 'required' : ''
        },

        ehContratoDeEngenharia() {
            return TIPOS_COM_BDI.includes(this.tipoContrato)
        }
    },

    validations() {
        return {
            tipoContrato: {
                required
            },
            numeroLicitacao: {
                required,
                formatoValido(value) {
                    if (!value) return true

                    const regex = /^\d{3}\/\d{4}-(CPL|CEL|CEA)$/
                    return regex.test(value)
                }
            },
            objetoContratacao: {
                required
            },
            bancos: {
                required: requiredIf(function () {
                    return this.ehContratoDeEngenharia
                })
            },
            encargosSociais: {
                required
            },
            planilha: {
                required: requiredIf(this.$route.name === 'PropostasPrecos_Nova')
            }
        }
    },

    methods: {
        aoSelecionarTipoContrato(novoTipo) {
            const eraEngenharia = this.ehContratoDeEngenharia

            this.tipoContrato = novoTipo
            this.$v.tipoContrato.$touch()

            const ehEngenharia = TIPOS_COM_BDI.includes(novoTipo)

            if (eraEngenharia !== ehEngenharia && (this.planilha || this.nomePlanilhaItens)) {
                this.planilha = null
                this.nomePlanilhaItens = ''
                this.$refs.selecaoArquivo.reset()
                this.$v.planilha.$reset()
            }
        },

        confirmarCancelar() {
            this.$swal({
                title: 'Proposta de Preço',
                html: 'Deseja realmente cancelar as alterações desta proposta de preço?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.cancelar()
                }
            })
        },

        cancelar() {
            this.$emit('recarregarListaBoletinsMedicao')
            this.$router.push({ name: 'PropostasPrecos' })
        },

        adicionarBanco() {
            this.bancos.push({
                descricao: this.banco,
                mesAnoReferencia: this.mesAnoReferencia,
                estado: this.estado
            })

            this.banco = null
            this.mesAnoReferencia = null
            this.estado = null
        },

        selecionarArquivo(event) {
            if (event.target.files && event.target.files.length > 0) {
                let arquivoSelecionado = event.target.files[0]

                this.planilha = {
                    nome: arquivoSelecionado.name,
                    arquivo: arquivoSelecionado,
                    data: new Date().toLocaleDateString(),
                    tamanho: arquivoSelecionado.size
                }

                this.$refs.selecaoArquivo.reset()
            } else {
                this.planilha = null
            }
        },

        baixarPlanilhaModelo() {
            const link = document.createElement('a')
            link.href = '/planilha-modelo-sem-bdi.xlsx'
            link.download = 'planilha-modelo.xlsx'

            link.click()
        },

        baixarInstrucoes() {
            const link = document.createElement('a')
            link.href = '/instrucoes-proposta-preco.pdf'
            link.download = 'instrucoes-proposta-preco.pdf'

            link.click()
        },

        async aoSelecionarPlanilha(file) {
            if (!file) {
                this.planilha = null
                this.$v.planilha.$touch()
                return
            }

            const resultado = this.ehContratoDeEngenharia
                ? await this.validarPlanilhaOrcaFascio(file)
                : await this.validarPlanilhaSemBDI(file)

            if (!resultado.valido) {
                this.planilha = null
                this.$refs.selecaoArquivo.reset()
                this.$toast.error(resultado.erro, 'Planilha inválida', this.$toastConfig.error)
                return
            }

            this.planilha = file
            this.$v.planilha.$touch()
        },

        async _parseXlsx(file) {
            let arquivos
            const errorMessage = 'O arquivo não é um arquivo Excel (.xlsx) válido.'

            try {
                arquivos = unzipSync(new Uint8Array(await file.arrayBuffer()))
            } catch {
                return { erro: errorMessage }
            }

            if (!arquivos['xl/workbook.xml'] || !arquivos['xl/worksheets/sheet1.xml']) {
                return { erro: errorMessage }
            }

            const sharedStrings = []
            if (arquivos['xl/sharedStrings.xml']) {
                const ssDoc = new DOMParser().parseFromString(
                    new TextDecoder().decode(arquivos['xl/sharedStrings.xml']), 'application/xml'
                )
                for (const si of ssDoc.getElementsByTagName('si')) {
                    let text = ''
                    for (const t of si.getElementsByTagName('t')) text += t.textContent
                    sharedStrings.push(text.trim())
                }
            }

            const rows = new DOMParser()
                .parseFromString(new TextDecoder().decode(arquivos['xl/worksheets/sheet1.xml']), 'application/xml')
                .getElementsByTagName('row')

            return { arquivos, sharedStrings, rows }
        },

        _lerValoresCelulas(row, sharedStrings) {
            const valores = {}
            for (const cell of row.getElementsByTagName('c')) {
                const col = cell.getAttribute('r').replace(/[0-9]/g, '')
                const type = cell.getAttribute('t')
                let value = ''

                if (type === 'inlineStr') {
                    const tEl = cell.getElementsByTagName('t')[0]
                    value = tEl ? tEl.textContent : ''
                } else {
                    const vEl = cell.getElementsByTagName('v')[0]
                    if (!vEl) continue
                    value = type === 's' ? (sharedStrings[parseInt(vEl.textContent)] || '') : vEl.textContent
                }

                valores[col] = value.trim()
            }

            return valores
        },

        async _validarCabecalhoPlanilha(file, { colunas, msgErro, workbookContains = null, colunasProibidas = [] }) {
            const normalizar = str =>
                str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

            const parsed = await this._parseXlsx(file)
            if (parsed.erro) return { valido: false, erro: parsed.erro }

            const { arquivos, sharedStrings, rows } = parsed

            if (workbookContains) {
                const workbookXml = new TextDecoder().decode(arquivos['xl/workbook.xml'])
                if (!normalizar(workbookXml).includes(normalizar(workbookContains)))
                    return { valido: false, erro: msgErro }
            }

            const MAX_LINHAS = Math.min(rows.length, 10)
            for (let i = 0; i < MAX_LINHAS; i++) {
                const valores = this._lerValoresCelulas(rows[i], sharedStrings)
                if (normalizar(valores['A'] || '') !== 'item') continue

                const celulas = Object.values(valores)

                const faltando = colunas.filter(col => !celulas.some(v => normalizar(v) === normalizar(col)))
                if (faltando.length > 0) return { valido: false, erro: msgErro }

                const proibida = colunasProibidas.find(col => celulas.some(v => normalizar(v) === normalizar(col)))
                if (proibida) return { valido: false, erro: msgErro }

                return { valido: true }
            }

            return { valido: false, erro: msgErro }
        },

        async validarPlanilhaOrcaFascio(file) {
            return this._validarCabecalhoPlanilha(file, {
                colunas: ['Item', 'Código', 'Banco', 'Descrição', 'Und', 'Quant.', 'Valor Unit', 'BDI Diferenciado' ,'Valor Unit com BDI', 'Total', 'Peso (%)'],
                msgErro: 'A planilha não segue o formato OrçaFascio.',
                workbookContains: 'Orçamento Sintético'
            })
        },

        async validarPlanilhaSemBDI(file) {
            return this._validarCabecalhoPlanilha(file, {
                colunas: ['Item', 'Código', 'Banco', 'Descrição', 'Und', 'Quant.'],
                msgErro: 'A planilha importada não corresponde ao modelo padrão. Baixe a planilha modelo e utilize-a para preencher sua proposta.',
                colunasProibidas: ['BDI Diferenciado']
            })
        },

        salvar() {
            this.$v.$touch()

            if (this.$v.$invalid) return

            this.$store.dispatch('addRequest')

            this.bancosFormatado = this.bancos
                .map(
                    (b) =>
                        `${b.descricao} - ${b.mesAnoReferencia} - ${b.estado}`
                )
                .join('; ')

            let dto = {
                numeroLicitacao: this.numeroLicitacao,
                objetoContratacao: this.objetoContratacao,
                tipoContrato: this.tipoContrato,
                bancos: this.bancosFormatado,
                encargosSociais: this.encargosSociais,
                planilha: this.planilha
            }

            PropostaPrecoServico.Adicionar(dto)
                .then((response) => {
                    if (response.errors && response.errors.length > 0) {
                        this.exibirErros('salvar', response.errors)
                        return
                    }

                    this.$toast.success(
                        'Formalização criada com sucesso!',
                        'OK',
                        this.$toastConfig.success
                    )

                    this.$router.push({
                        name: 'PropostasPrecos_Detalhe',
                        params: {
                            propostaPrecoId: response.data.data.propostaPrecoId
                        }
                    })
                })
                .catch((error) => {
                    this.exibirErros('salvar', error)
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        atualizar() {
            this.$v.$touch()

            if (this.$v.$invalid) return

            this.$store.dispatch('addRequest')

            this.bancosFormatado = this.bancos
                .map(
                    (b) =>
                        `${b.descricao} - ${b.mesAnoReferencia} - ${b.estado}`
                )
                .join('; ')

            let dto = {
                propostaPrecoId: this.propostaPrecoId,
                numeroLicitacao: this.numeroLicitacao,
                objetoContratacao: this.objetoContratacao,
                tipoContrato: this.tipoContrato,
                bancos: this.bancosFormatado,
                encargosSociais: this.encargosSociais,
                planilha: this.planilha
            }

            PropostaPrecoServico.Atualizar(dto)
                .then((response) => {
                    if (response.errors && response.errors.length > 0) {
                        this.exibirErros('atualizar', response.errors)
                        return
                    }

                    this.$toast.success(
                        'Formalização atualizada com sucesso!',
                        'OK',
                        this.$toastConfig.success
                    )

                    this.$router.push({
                        name: 'PropostasPrecos_Detalhe',
                        params: {
                            propostaPrecoId: response.data.data.propostaPrecoId
                        }
                    })
                })
                .catch((errors) => {
                    this.exibirErros('atualizar', errors)
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        exibirErros(acao, errors) {
            const tituloToast =
                acao === 'salvar'
                    ? 'Erro ao criar formalização!'
                    : 'Erro ao atualizar formalização!'
            const mensagemErro =
                acao === 'salvar'
                    ? 'Erro ao salvar proposta de preço:'
                    : 'Erro ao atualizar proposta de preço:'

            this.erros = [`${mensagemErro} ${errors}`]
            this.$toast.error(tituloToast, 'Erro', this.$toastConfig.error)
        },

        converterParaListaBancos(bancosStr) {
            if (!bancosStr || typeof bancosStr !== 'string') return []

            return bancosStr
                .split(';')
                .map((item) => {
                    const partes = item.split(' - ').map((p) => p.trim())
                    return {
                        descricao: partes[0] || '',
                        mesAnoReferencia: partes[1] || '',
                        estado: partes[2] || ''
                    }
                })
                .filter((b) => b.descricao || b.mesAnoReferencia || b.estado)
        },

        obterPropostaPreco() {
            this.$store.dispatch('addRequest')

            PropostaPrecoServico.ObterPorId(this.$route.params.propostaPrecoId)
                .then((response) => {
                    this.propostaPrecoId = response.data.propostaPrecoId
                    this.numeroLicitacao = response.data.numeroLicitacao
                    this.objetoContratacao = response.data.objetoContratacao
                    this.tipoContrato = response.data.tipoContrato
                    this.bancos = this.converterParaListaBancos(
                        response.data.bancos
                    )
                    this.encargosSociais = response.data.encargosSociais
                    this.nomePlanilhaItens = response.data.nomePlanilhaItens
                })
                .catch((error) => {
                    console.error('Erro ao obter propostas de preços:', error)
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    mounted() {
        if (this.$route.name === 'PropostasPrecos_Editar') {
            this.obterPropostaPreco()
        }
    }
}
</script>

<style>
.planilha-upload-primary .custom-file-label::after {
    color: #fff;
    background-color: var(--primary, #007bff);
    border-color: var(--primary, #007bff);
}
</style>
